<template>

    <v-tooltip top
               color="primary"
               max-width="500"
               open-delay="100">

        <template v-slot:activator="{ on }">

            <!--TOOLTIP CONTENTS -->
            <v-card
                class="d-flex align-self-center ml-1 pa-1 justify-center cursor-help"
                v-on="on"
                :color="feasibilityRunning ? 'grey' : componentColor"
                style="margin-bottom: auto; margin-top: auto;"
                elevation="0"
                min-width="50"
                max-width="50"
                height="36">

                <div v-if="!feasibilityRunning"
                     class="body-1 align-self-center">

                    <div v-if="item.boost && item.status==='active'">
                        <v-icon color="grey lighten-2">
                            {{ boostIcon }}
                        </v-icon>
                    </div>

                    <v-icon v-if="item.status==='cool'" color="grey lighten-2">
                        mdi-snowflake
                    </v-icon>

                    <v-icon v-if="item.status==='complete'">
                        mdi-check
                    </v-icon>

                    <v-icon v-if="item.status==='idle'">
                        mdi-timelapse
                    </v-icon>

                </div>

                <!-- LOADER -->
                <v-progress-circular v-if="feasibilityRunning"
                                     class="body-1 align-self-center"
                                     color="white"
                                     width="2"
                                     size="20"
                                     indeterminate
                ></v-progress-circular>

            </v-card>

        </template>

        <div class="pa-2">

            <div v-if="item.status==='complete'" class="body-1 mb-1">
                <b>COMPLETED</b>
            </div>

            <div v-if="item.status==='active'" class="body-1 mb-1">
                <b>ACTIVE:</b>
            </div>

            <div v-if="item.status==='cool'" class="body-1 mb-1">
                <b>COOLING DOWN</b>
            </div>

            <div v-if="item.status==='idle'" class="body-1 mb-1">
                <b>IDLING</b>
            </div>

            <div>
                Invited: <b>{{ item.invited_count.toLocaleString() }}</b>
            </div>

            <div>
                Outstanding invitations: <b>{{ item.outstanding_invite_count }}</b>
            </div>

            <div>
                Outstanding completes: <b>{{ item.outstanding_completes }}</b>
            </div>

            <div>
                Response rate: <b>{{ responseRateFormatted }}</b>
            </div>

            <div>
                Current sessions: <b>{{ item.current_sessions }}</b>
            </div>

            <div v-if="item.boost !== null">
                Sampling boost: {{ item.boost }}
            </div>


        </div>

    </v-tooltip>
</template>

<script>

export default {

    props: {
        item: {
            type: Object,
            required: true,
        },

        feasibilityRunning: {
            type: Boolean,
            required: true,
            default: false,
        },
    },

    computed: {

        responseRateFormatted() {
            return this.responseRate ? (Math.round(this.responseRate * 10000) / 100) +"%": "Unknown";
        },

        responseRate() {
            if (this.item.invited_count === 0) return null;
            return this.item.count / this.item.invited_count;
        },

        componentColor() {
            if (this.item.status === 'idle') return "grey darken-1"
            if (this.item.status === 'cool') return "light-blue darken-2";
            if (this.item.status === 'complete') return "green";

            if (this.item.status === 'active') {

                if (this.boostIcon.includes('triple')) return "red darken-2";
                if (this.boostIcon.includes('double')) return "orange darken-2";

                return "grey darken-1";
            }
        },

        boostIcon() {

            if (this.item.boost < 0.2) return "mdi-chevron-triple-down";
            if (this.item.boost < 0.5) return "mdi-chevron-double-down";
            if (this.item.boost < 0.9) return "mdi-chevron-down";

            if (this.item.boost > 2.0) return "mdi-chevron-triple-up";
            if (this.item.boost > 1.5) return "mdi-chevron-double-up";
            if (this.item.boost > 1.1) return "mdi-chevron-up";

            return "mdi-circle-medium";
        }
    }
}
</script>
